<template>
    <div>

    </div>
</template>

<script>
export default {
    name: 'left-nav',
    data() {
        return {
            
        }
    }
    
}
</script>





// WEBPACK FOOTER //
// src/components/website/shared/left-nav.vue